<template>
    <div class="app-logins-component">
        <div class="page-layout__group">
            <table class="table  table--noborder table-zebra">
                <thead class="table__head">
                    <tr class="table__row">
                        <td class="table__cell  table__hcell" colspan="2">
                            <form @submit.prevent="fetchAppLogins">
                                <div class="field-advanced">
                                    <div class="field-advanced__inner">
                                        <div class="field-advanced__field-wrap">
                                            <input type="text" :placeholder="getTranslation('searchByfioPin')" v-model="filterForm.query" class="field  field--full-width  field--bg-grey  js-borderOnFocus"></div>
                                        <div class="field-advanced__right">
                                            <button class="btn  btn--square  btn--main">
                                                <svg class="btn__icon">
                                                    <use xlink:href="#icon__search"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </td>
                        <td class="table__cell  table__hcell">
                            <v-select
                                    :options="formOptions.loginTypes"
                                    label="title"
                                    v-model="filterForm.loginType"
                                    :reduce="option=>option.id"
                                    :placeholder="getTranslation('selectFromList')"
                            />
                        </td>
                        <td class="table__cell  table__hcell" colspan="2">
                            <v-select
                                    :options="formOptions.statuses"
                                    label="title"
                                    v-model="filterForm.status"
                                    :reduce="option=>option.id"
                                    :placeholder="getTranslation('selectFromList')"
                            />
                        </td>
                    </tr>
                    <tr class="table__row">
                        <th class="table__cell  table__hcell" style="width:30%">{{getTranslation('candidates')}} - {{ pagination.total }}</th>
                        <th class="table__cell  table__hcell" style="width:15%">{{ getTranslation('ipAddress') }}</th>
                        <th class="table__cell  table__hcell" style="width:20%">{{ getTranslation('identification') }}</th>
                        <th class="table__cell  table__hcell" style="width:15%">{{ getTranslation('status') }}</th>
                        <th class="table__cell  table__hcell" style="width:20%">{{ getTranslation('loginDate') }}</th>
                    </tr>
                </thead>
                <tbody class="table__body">
                    <tr v-for="item in logins" v-bind:key="item.id" class="table__row">
                        <td class="table__cell">
                            <!-- PERSON -->
                            <div class="person">
                                <div class="person__inner">
                                    <div class="person__img" :class="{'person__img--online':item.isOnline,'person__img--offline':!item.isOnline}">
                                        <a href="javascript:void(0)">
                                            <img :src="item.photoUrl || $config.noAvatarUrl" alt="Фото сотрудника">
                                        </a>
                                    </div>

                                    <div class="person__info">
                                        <h3 class="person__name">
                                            <router-link :to="{name:'api.candidate.get',params:{id:item.candidateId},query:{appId:appId,tab:'logins'}}" class="person__link">{{item.fullName}}</router-link>
                                        </h3>
                                        <div class="person__descr">{{item.pin}}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- / PERSON -->
                        </td>
                        <td class="table__cell">
                            {{ item.ip }}
                        </td>
                        <td class="table__cell">
                            {{ getTranslation(item.loginTypeText) }}
                        </td>
                        <td class="table__cell">
                              <span v-if="item.testingStatus === 'CANDIDATE_AUTHORIZED' && item.status===1" class="badge ml-2">
                                  {{ getTranslation(item.testingStatus) }}
                             </span>
                            <span v-if="item.status !== 1">
                                {{ getTranslation(item.statusText) }}
                            </span>
                            <TestingStatusCardComponent v-if="item.testingStatus !== 'CANDIDATE_AUTHORIZED' && item.status===1 " :testing-status="item.testingStatus" :testing-event-candidate="item.testingCandidateEvent" />
                        </td>
                        <td class="table__cell">
                            {{ item.creationDate }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
            <pagination :pagination="pagination" @change="()=>{fetchAppLogins();this.$scrollTo('.app-logins-component');}" v-model="filterForm.page"></pagination>
        </div>
    </div>
</template>

<script>
    import TestingStatusCardComponent from "./TestingStatusCardComponent";

    export default {
        name: "AppLoginsComponent",
        components: { TestingStatusCardComponent },
        props: ['appId', 'active'],
        data() {
            return {
                filterForm: {},
                formOptions: {
                    statuses: [],
                    loginTypes: []
                },
                logins: [],
                pagination: {
                    total: '',
                    lastPage: '',
                    currentPage: ''
                },
                loadSelects: false,
            }
        },
        created() {
            if ( this.active ) {
                this.fetchAppLogins();
                this.fetchLoginOptions().then( () => {
                    this.loadSelects = true;
                } )
            }
        },
        watch: {
            active( val ) {
                if ( val ) {
                    this.fetchAppLogins();
                    this.fetchLoginOptions().then( () => {
                        this.loadSelects = true;
                    } )
                }
            },
            'filterForm.status'() {
                this.fetchAppLogins();
            },
            'filterForm.loginType'() {
                this.fetchAppLogins();
            }
        },
        methods: {
            fetchLoginOptions() {
                return this.axios.get( this.$config.urls.candidate.loginOptions.url )
                           .then( response => {
                               this.formOptions.statuses = this.objectToArray( response.data.data.statuses, true, true );

                               this.formOptions.loginTypes = this.objectToArray( response.data.data.loginTypes, true, true );
                           } ).catch(()=>{});
            },
            fetchAppLogins() {
                let params = this.cleanObject( this.filterForm );
                return this.axios.get( this.$config.urls.application.getAppLogins.url.replace( ':id', this.appId ), { params: params } )
                           .then( response => {

                               this.logins = response.data.data.items;
                               this.pagination.currentPage = response.data.data.activePage;
                               this.filterForm.page = response.data.data.activePage;
                               this.pagination.total = response.data.data.totalItemsCount;
                               this.pagination.lastPage = response.data.data.pages;

                           } ).catch(()=>{});
            }
        }
    }
</script>

<style scoped>

</style>
